import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { FAQS } from '../data/content';
import { Reveal, Eyebrow } from './Reveal';

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="border-y border-bronze/20 bg-paper">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-24 md:px-10 md:py-32 lg:grid-cols-12 lg:gap-16">
      <div className="lg:col-span-5">
        <Eyebrow>Common Questions</Eyebrow>
        <Reveal>
          <h2 className="mt-4 font-serif text-3xl font-light leading-tight text-espresso sm:text-4xl lg:text-5xl">
            Straight answers,<br />
            <span className="italic text-bronze">before you ask.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-sm text-sm font-light leading-relaxed text-stone md:text-base">
            The things every family asks us before their first meeting. If yours isn't here, send it
            through the form — we answer every message.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-bronze/25">
              <AccordionTrigger className="py-6 text-left font-serif text-lg font-normal text-espresso hover:text-bronze hover:no-underline md:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm font-light leading-relaxed text-stone md:text-base">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
